export default class Door{
    constructor(a){
        if(typeof a === 'object'){
            this.height = 200
            this.width = a.width || 70
            // this.position = a.position || 50
            this.isDoor = true
            this.padding = 10
            this.heightFromFloor = 0
            this.id = ''
        }
        else{
            this.height = 200
            this.width = 70
            // this.position = 50
            this.isDoor = true
            this.padding = 10
            this.heightFromFloor = 0
            this.id = ''
        }
    }
}
